import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export class UnableToRetreiveDemandError extends Error {
    public error: HttpErrorResponse;
    public status: HttpStatusCode;

    constructor(e: HttpErrorResponse) {
        super(e.message);
        this.error = e;
        this.status = e.status;
    }
}
